import { cartService } from '../api/cart';
import { wishlistService } from '../api/wishlist';
import type { CartItem } from '../context/CartContext';
import { consumePendingAuthAction, type PendingAuthAction } from './pendingAuthAction';

export type PendingActionHandlers = {
  addToCartLocal: (item: CartItem) => void;
  navigate: (path: string, options?: { state?: unknown }) => void;
};

export async function runPendingAuthAction(
  action: PendingAuthAction | null,
  handlers: PendingActionHandlers
): Promise<string | null> {
  if (!action) return null;

  switch (action.type) {
    case 'addToCart': {
      await cartService.addToCart(action.productId, action.quantity);
      if (action.localItem) {
        handlers.addToCartLocal(action.localItem);
      }
      return '/cart';
    }
    case 'buyNow':
      handlers.navigate('/checkout', {
        state: { isBuyNow: true, buyNowProduct: action.buyNowProduct },
      });
      return '/checkout';
    case 'wishlist':
      if (action.add) {
        await wishlistService.addToWishlist(action.productId);
      } else {
        await wishlistService.removeFromWishlist(action.productId);
      }
      return null;
    case 'navigate':
      handlers.navigate(action.path);
      return action.path;
    default:
      return null;
  }
}

export async function resumePendingAuthActionAfterLogin(
  handlers: PendingActionHandlers
): Promise<string | null> {
  const action = consumePendingAuthAction();
  return runPendingAuthAction(action, handlers);
}
